/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Selection of peer review status options
 * @export
 */
export const EReviewStatus = {
    Approved: 'APPROVED',
    ApprovedWithUpdates: 'APPROVED_WITH_UPDATES',
    NotApproved: 'NOT_APPROVED',
    ReferToBinder: 'REFER_TO_BINDER'
} as const;
export type EReviewStatus = typeof EReviewStatus[keyof typeof EReviewStatus];


export function instanceOfEReviewStatus(value: any): boolean {
    for (const key in EReviewStatus) {
        if (Object.prototype.hasOwnProperty.call(EReviewStatus, key)) {
            if (EReviewStatus[key as keyof typeof EReviewStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EReviewStatusFromJSON(json: any): EReviewStatus {
    return EReviewStatusFromJSONTyped(json, false);
}

export function EReviewStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EReviewStatus {
    return json as EReviewStatus;
}

export function EReviewStatusToJSON(value?: EReviewStatus | null): any {
    return value as any;
}

export function EReviewStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EReviewStatus {
    return value as EReviewStatus;
}

